<template>
  <div v-if="filteredChanges.length" class="changelog-dropdown-wrapper">
    <b-dropdown
      size="sm"
      variant="link"
      toggle-class="text-decoration-none p-0"
      no-caret
      right>

      <template v-slot:button-content>
        <span
          class="changelog-trigger"
          :class="{ 'changelog-pulse': hasRecentChanges }"
          :title="hasRecentChanges ? '' : 'Historial de cambios del módulo'">
          <i class="fa fa-history"></i>
          <span v-if="hasRecentChanges" class="changelog-trigger-label">Novedades</span>
          <b-badge v-if="hasRecentChanges" variant="danger" pill class="changelog-badge">
            {{ recentCount }}
          </b-badge>
        </span>
      </template>

      <b-dropdown-header class="changelog-dropdown-header">
        Últimos cambios
      </b-dropdown-header>

      <b-dropdown-divider></b-dropdown-divider>

      <div class="changelog-dropdown-body">
        <div
          v-for="(item, index) in filteredChanges"
          :key="index"
          class="changelog-dropdown-item"
          :class="{ 'changelog-dropdown-item-new': isRecent(item) }">

          <div class="d-flex align-items-center justify-content-between">
            <small class="text-muted">{{ formatDate(item.date) }}</small>
            <span v-if="isRecent(item)" class="changelog-new">Nuevo</span>
          </div>
          <p class="mb-0 mt-1">{{ item.description }}</p>
        </div>
      </div>

      <b-dropdown-divider></b-dropdown-divider>

      <b-dropdown-item @click="goToChangelog()" class="text-center">
        <small class="text-muted">Ver más <i class="fa fa-chevron-right"></i></small>
      </b-dropdown-item>

    </b-dropdown>
  </div>
</template>

<script>
  import changelogData from '@/components/changelog/data.json'
  import Session from '@/handler/session'

  export default {
    props: {
      moduleKey: {
        type: String,
        default: ''
      },
      limit: {
        type: Number,
        default: 5
      }
    },
    computed: {
      filteredChanges() {
        var userModules = this.getUserModules()
        var data = changelogData.slice()

        if (userModules.length) {
          data = data.filter(item => userModules.indexOf(item.module) !== -1)
        }

        if (this.moduleKey) {
          data = data.filter(item => item.module === this.moduleKey)
        }

        data.sort((a, b) => b.date.localeCompare(a.date))

        return data.slice(0, this.limit)
      },
      hasRecentChanges() {
        return this.recentCount > 0
      },
      recentCount() {
        var today = new Date()
        var thirtyDaysAgo = new Date(today.getTime() - (30 * 24 * 60 * 60 * 1000))
        var limitDate = thirtyDaysAgo.toISOString().substring(0, 10)

        return this.filteredChanges.filter(item => item.date >= limitDate).length
      }
    },
    methods: {
      isRecent(item) {
        var today = new Date()
        var thirtyDaysAgo = new Date(today.getTime() - (30 * 24 * 60 * 60 * 1000))
        var limitDate = thirtyDaysAgo.toISOString().substring(0, 10)
        return item && item.date >= limitDate
      },
      getUserModules() {
        var modules = []
        if (Session.getSession().auth && Session.getSession().auth.user.permissions) {
          var menu = Session.getSession().auth.user.permissions.menu
          for (var prop in menu) {
            modules.push(menu[prop].router)
          }
        }
        return modules
      },
      formatDate(dateStr) {
        var parts = dateStr.split('-')
        return parts[2] + '/' + parts[1] + '/' + parts[0]
      },
      goToChangelog() {
        var query = {}
        if (this.moduleKey) {
          query.module = this.moduleKey
        }
        this.$router.push({ name: 'ChangelogStaff', query: query })
      }
    }
  }
</script>

<style scoped>
  .changelog-dropdown-wrapper {
    display: inline-block;
  }
  .changelog-trigger {
    color: #6c757d;
    font-size: 12px;
    cursor: pointer;
    padding: 4px 10px;
    border: 1px solid #d8dbe0;
    border-radius: 20px;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    transition: all 0.2s;
  }
  .changelog-trigger:hover {
    color: #333;
    border-color: #999;
  }
  .changelog-trigger-label {
    font-size: 11px;
  }
  .changelog-badge {
    font-size: 9px;
    padding: 2px 5px;
  }
  .changelog-pulse {
    animation: pulse-glow 2s ease-in-out infinite;
  }
  @keyframes pulse-glow {
    0%, 100% {
      box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.4);
    }
    50% {
      box-shadow: 0 0 8px 3px rgba(220, 53, 69, 0.3);
    }
  }
  .changelog-dropdown-header {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .changelog-dropdown-body {
    max-height: 280px;
    overflow-y: auto;
    min-width: 300px;
  }
  .changelog-dropdown-item {
    padding: 8px 16px;
    border-left: 3px solid #20a8d8;
    margin: 0 8px 4px 8px;
    font-size: 12px;
    line-height: 1.3;
  }
  .changelog-dropdown-item-new {
    border-left-color: #ffcc6a;
  }
  .changelog-dropdown-item:last-child {
    margin-bottom: 0;
  }
  .changelog-new {
    font-size: 9px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    background: #ffe8a1;
    color: #7a5b00;
    border: 1px solid #ffd56a;
    border-radius: 10px;
    padding: 1px 6px;
  }
</style>
